export const c_table_thead_m_nested_column_header_tr_PaddingTop = {
  "name": "--pf-c-table--thead--m-nested-column-header--tr--PaddingTop",
  "value": "0.25rem",
  "var": "var(--pf-c-table--thead--m-nested-column-header--tr--PaddingTop)"
};
export default c_table_thead_m_nested_column_header_tr_PaddingTop;